<template>
  <div class="dialog_school">
    <el-dialog
      :title="has_password ? '修改密码' : '设置密码'"
      class="dialog_school_content"
      :visible.sync="showPwdModal"
      :before-close="closeModal"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      width="450px">
      <div class="form">
        <el-form
          size="small"
          class="form"
          label-width="80px"
          :model="form"
          ref="form"
          :rules="rules"
          status-icon
          label-position="left"
        >
          <el-form-item class="dialog_school_item" prop="phone_mobile" v-if="!isStudent">
            <el-input :placeholder="form.phone_mobile" type="text" v-model.trim="form.mobile"></el-input>
          </el-form-item>
          <el-form-item  class="dialog_school_item" prop="captcha" v-if="!isStudent">
            <el-col :span="14">
              <el-input
                placeholder="验证码"
                type="text"
                auto-complete="off"
                v-model="form.captcha"
                :maxlength="6"
              ></el-input>
            </el-col>
            <el-col :span="9" :offset="1">
              <countdown-btn
                :disabled.sync="isBtnDisabled"
                ref="countdownBtn"
                id="bindAccBtn"
                el="div"
                class="el-button el-button--primary el-button--small"
                placeholder="获取验证码"
                lockTmp="%s秒后重试"
                clickTips="请稍后"
                @click="getCapcha"
              />
            </el-col>
          </el-form-item>
          <el-form-item class="dialog_school_item" v-if="isStudent" prop="old_pwd">
            <el-input
              v-model="form.old_pwd"
              :minlength="6"
              :maxlength="20"
              type="password"
              placeholder="请输入原始密码"
            ></el-input>
          </el-form-item>
          <el-form-item class="dialog_school_item" prop="pwd">
            <el-input
              v-model="form.pwd"
              :minlength="6"
              :maxlength="20"
              type="password"
              placeholder="请输入6至20位的数字、字母组合密码"
            ></el-input>
          </el-form-item>
          <el-form-item class="dialog_school_item" prop="rePwd">
            <el-input
              v-model="form.rePwd"
              :minlength="6"
              :maxlength="20"
              type="password"
              placeholder="请再次输入新密码"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="footer">
          <el-button class="dialog_school_close" @click="closeModal">取 消</el-button>
          <el-button class="dialog_school_submit" @click="confirm" v-loading="loading">确认</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CountdownBtn from '@/components/CountdownBtn'
import { SpecialCharacters } from '@/utils/utils'
import { mapState } from 'vuex'

export default {
  props: {
    showPwdModal: Boolean
  },
  components: {
    CountdownBtn
  },
  data() {
    const validatePhoneNumber = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入正确的手机号'))
      } else {
        const phoneNumberCheck = /^(0|86|17951)?(1[3-9])\d{9}$/
        if (phoneNumberCheck.test(value) === false) {
          callback(new Error('请输入正确的手机号'))
        }
        callback()
      }
    }
    const validateCheckNumber = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入验证码'))
      } else if (isNaN(value)) {
        callback(new Error('验证码为数字'))
      } else {
        callback()
      }
    }
    const checkOldPwd = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入原始密码'))
      } else {
        callback()
      }
    }
    const checkPwd = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else if (!SpecialCharacters.test(value)) {
        callback(new Error('密码中不可包含特殊字符'))
      } else if (!/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,20}$/.test(value)) {
        callback(new Error('请输入6至20位数字、字母组合密码'))
      } else if (value !== this.form.rePwd && this.form.rePwd.length > 0) {
        validateRePwd(rule, this.form.pwd, callback)
      } else {
        callback()
      }
    }

    const validateRePwd = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请再输入密码'))
      } else if (value.length < 6 || value.length > 20) {
        callback(new Error('请输入6至20位数字、字母组合密码'))
      } else if (!SpecialCharacters.test(value)) {
        callback(new Error('密码中不可包含特殊字符'))
      } else if (value !== this.form.pwd) {
        callback(new Error('两次输入密码不一致'))
      } else if (value !== this.form.rePwd) {
        callback(new Error('两次输入密码不一致'))
      } else {
        callback()
      }
    }

    return {
      loading: false,
      form: {
        phone_mobile: '', // 显示带星号的输入框
        mobile: '',
        captcha: '',
        old_pwd: '',
        pwd: '',
        rePwd: ''
      },
      rules: {
        mobile: [{ validator: validatePhoneNumber, trigger: 'blur' }],
        captcha: [{ validator: validateCheckNumber, trigger: 'blur' }],
        old_pwd: [{ validator: checkOldPwd, trigger: 'blur' }],
        pwd: [{ validator: checkPwd, trigger: 'blur' }],
        rePwd: [{ validator: validateRePwd, trigger: 'blur' }]
      }
    }
  },
  computed: {
    ...mapState([
      'user',
      'teacherRegister',
      'customInfo'
    ]),
    isBtnDisabled() {
      return !/^(0|86|17951)?(1[3-9])\d{9}$/.test(this.form.mobile)
    },
    phone() {
      return this.$store.state.user.phone
    },
    has_password() {
      return this.$store.state.user.has_password
    },
    modalText() {
      const _has_pwd = this.$store.state.user.has_password
      return _has_pwd ? '修改' : '设置'
    },
    isStudent() {
      return this.$store.getters.roleType === 'student'
    }
  },
  watch: {
    user: {
      handler (val) {
        if (val.phone_number) {
          this.form.mobile = ''
          this.form.phone_mobile = val.phone_number
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted () {
    this.$store.dispatch('changeThemeColor', {
      themeColor: '#FFA21C'
    })
    // this.getJiYanConfigInfo()
  },
  methods: {
    closeModal() {
      this.$emit('closeModal')
    },
    async getCapcha(lock, reset) {
      try {
        this.$verify({
          identity: this.form.mobile,
          dom_id: 'capcha_dom_id',
          success_callback: this.sendResetCapcha,
          fail_callback: reset,
          close_callback: reset
        })
      } catch (error) {
        reset()
      }
    },
    async saveByPhone() {
      const countdownBtn = this.$refs.countdownBtn
      try {
        this.$auth(
          'change_pwd_by_phone',
          this.form.mobile,
          this.form.captcha,
          this.form.pwd
        ).then((data) => {
          this.$message.success(`${this.modalText}成功`)
          const url = window.CONFIG.school
          this.$emit('closeModal')
          window.location.href = `${url}/login`
        })
      } catch (error) {
        countdownBtn.reset()
      }
    },
    async saveByPassword() {
      this.$auth(
        'change_pwd_by_old',
        this.form.old_pwd,
        this.form.pwd,
        this.form.rePwd
      ).then((data) => {
        this.$message.success(`${this.modalText}成功`)
        const url = window.CONFIG.school
        this.$emit('closeModal')
        window.location.href = `${url}/login`
      })
    },
    async confirm() {
      await this.$refs.form.validate()
      return this.isStudent ? this.saveByPassword() : this.saveByPhone()
    },
    async sendResetCapcha (ticket) {
      const countdownBtn = this.$refs.countdownBtn
      try {
        await this.$auth('change_pwd_by_phone_captcha', this.form.mobile, ticket)
        this.$message.success('验证码已发送至手机')
        countdownBtn.lock()
      } catch (error) {
        countdownBtn.reset()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.foot {
  margin-top: 30px;
  width: 100%;
  text-align: center;
}
.form {
  margin: 0 auto;
}
/deep/ .count-down-btn {
  width: 100%;
  height: 38px;
  line-height: 19px;
}
.dialog_school {
  position: absolute;
  right: -105px;
  top: 0px;
  .dialog_school_btn {
    color: #00C4AA;
    font-size: 12px;
  }
  .dialog_school_tip {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 20px;
    margin-bottom: 16px;
    text-align: center;
  }
  .dialog_school_content {
    /deep/ .el-form-item__content {
      margin-left: 0!important;
    }
    /deep/ .el-dialog__header {
      text-align: center;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 22px;
    }
    /deep/ .el-cascader__label {
      line-height: 39px;
    }
    /deep/ .el-input__inner {
      height: 39px;
      line-height: 39px;
    }
    .footer {
      margin-top: 80px;
      display: flex;
      align-items: center;
      justify-content:center;
    }
    .dialog_school_item {
      line-height: 39px;
      padding: 0 25px 2px;
    }
    .dialog_school_submit {
      width: 88px;
      height: 32px;
      background-color: #FFA21C;
      border: 1px solid #ffa21c;
      color: #fff;
      border-radius: 4px;
      &:hover {
        opacity: 0.7;
      }
    }
    .dialog_school_close {
      width: 88px;
      height: 32px;
    }
  }
}
</style>
